import React from 'react';
import { Shield } from 'lucide-react';

const ResistanceIndicator = ({ level = 1, maxLevel = 5, size = 'sm' }) => {
  const sizes = {
    xs: { dot: 'w-2 h-2', gap: 'gap-0.5', text: 'text-[10px]' },
    sm: { dot: 'w-2.5 h-2.5', gap: 'gap-1', text: 'text-xs' },
    md: { dot: 'w-3 h-3', gap: 'gap-1', text: 'text-sm' },
  };
  const s = sizes[size] || sizes.sm;

  return (
    <div className={`flex items-center ${s.gap}`} data-testid="resistance-indicator">
      <Shield className={`${size === 'xs' ? 'w-3 h-3' : 'w-3.5 h-3.5'} text-accent/70 flex-shrink-0`} />
      <div className={`flex items-center ${s.gap}`}>
        {Array.from({ length: maxLevel }, (_, i) => (
          <span
            key={i}
            className={`${s.dot} rounded-full transition-colors ${
              i < level ? 'bg-accent' : 'bg-border'
            }`}
          />
        ))}
      </div>
      <span className={`${s.text} text-muted-foreground ml-0.5`}>{level}/{maxLevel}</span>
    </div>
  );
};

export default ResistanceIndicator;
